// extracted by mini-css-extract-plugin
export default {"menuList":"ReportsMenu_menuList__yBstz"};